const ListarFornecedores = () => import('@/domains/shared/cadastros/fornecedores/views/Listar')
const AdicionarFornecedor = () => import('../views/Adicionar')
const EditarFornecedor = () => import('../views/Editar')
const VisualizarFornecedor = () => import('../views/Visualizar')
const ImportarCadastrosFornecedores = () => import('@/domains/shared/cadastros/fornecedores/views/Importar')
const routes = [
    {
        name: 'listarFornecedoresEmissor',
        path: '/emissor/fornecedores',
        alias: ['/emissor/fornecedores/index'],
        component: ListarFornecedores,
    },
    {
        name: 'adicionarFornecedoresEmissor',
        path: '/emissor/fornecedores/adicionar',
        component: AdicionarFornecedor,
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'editarFornecedoresEmissor',
        path: '/emissor/fornecedores/editar/:id',
        component: EditarFornecedor,
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'visualizarFornecedoresEmissor',
        path: '/emissor/fornecedores/visualizar/:id',
        component: VisualizarFornecedor,
    },
    {
        name: 'importarCadastrosFornecedoresEmissor',
        path: '/emissor/fornecedores/importar_cadastros',
        component: ImportarCadastrosFornecedores,
    }
]

export default routes
